export enum EmailIdentityType {
  Unknown,
  EmailAddress,
  Domain
}
